"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _message = require('shared/validation/chat/message');

// A plain-SMS text longer than one SMS (1,600 characters) goes as numbered
// texts, "[1/3] …", each a message of its own, instead of being cut.

 const SMS_PART_LENGTH = _message.MAX_SMS_LENGTH; exports.SMS_PART_LENGTH = SMS_PART_LENGTH
// The field's sanity cap in a plain-SMS chat.
 const PLAIN_SMS_MAX_LENGTH = 10000; exports.PLAIN_SMS_MAX_LENGTH = PLAIN_SMS_MAX_LENGTH

const COUNTER_THRESHOLD = 0.8
const URL_PATTERN = /\b(?:https?:\/\/|www\.)\S+/gi
const PHONE_PATTERN = /(?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b/g
const PARAGRAPH_BREAK = /\n[ \t]*\n/g
const SENTENCE_END = /[.!?]["'”’)\]]*(?=\s)/g
const WHITESPACE = /\s/g



// Links and phone numbers are never split.
const protectedSpans = (text) =>
  [URL_PATTERN, PHONE_PATTERN].flatMap(pattern =>
    Array.from(text.matchAll(pattern), (m) => [m.index, m.index + m[0].length]))

const lastCut = (window, pattern, cutAt, ok) => {
  let best = -1
  for (const m of window.matchAll(pattern)) {
    const cut = cutAt(m)
    if (cut > 0 && ok(cut)) best = cut
  }
  return best
}

// Where the part starting at `from` ends: the last paragraph break, then
// sentence end, then whitespace within `room`, outside any link or phone
// number; a hard cut only for an unbroken run.
const cutPoint = (text, from, room, spans) => {
  const limit = from + room
  if (text.length <= limit) return text.length
  const window = text.slice(from, limit + 1)
  const ok = (cut) => from + cut <= limit &&
    !spans.some(([start, end]) => from + cut > start && from + cut < end)
  for (const [pattern, cutAt] of [
    [PARAGRAPH_BREAK, (m) => m.index],
    [SENTENCE_END, (m) => m.index + m[0].length],
    [WHITESPACE, (m) => m.index],
  ] ) {
    const cut = lastCut(window, pattern, cutAt, ok)
    if (cut > 0) return from + cut
  }
  // Not between the halves of a surrogate pair.
  const code = text.charCodeAt(limit - 1)
  return code >= 0xd800 && code <= 0xdbff ? limit - 1 : limit
}



const splitRanges = (text, room) => {
  const spans = protectedSpans(text)
  const ranges = []
  let from = 0
  while (from < text.length) {
    const cut = cutPoint(text, from, room, spans)
    let to = cut
    while (to > from && /\s/.test(text[to - 1])) to -= 1
    ranges.push({ from, to })
    from = cut
    while (from < text.length && /\s/.test(text[from])) from += 1
  }
  return ranges
}

const prefix = (n, count) => `[${n}/${count}] `

// The parts' ranges in the text, sized for their "[n/N] " prefixes.
const partRanges = (text) => {
  let count = 2
  for (;;) {
    const ranges = splitRanges(text, exports.SMS_PART_LENGTH - prefix(count, count).length)
    // A count with no more digits than the one sized for fits.
    if (String(ranges.length).length <= String(count).length) return ranges
    count = ranges.length
  }
}

/** The texts a plain SMS goes out as: the text itself when it fits. */
 const splitSmsText = (text) => {
  if (text.length <= exports.SMS_PART_LENGTH) return [text]
  const ranges = partRanges(text)
  return ranges.map((r, i) => prefix(i + 1, ranges.length) + text.slice(r.from, r.to))
}; exports.splitSmsText = splitSmsText

/** As splitSmsText, with the mentions: they stay on part 1, moved past its
 * prefix; a mention in a later part goes as plain text. */
 const splitSmsMessage = (text, mentions) => {
  if (text.length <= exports.SMS_PART_LENGTH) return [{ text, mentions }]
  const ranges = partRanges(text)
  return ranges.map((r, i) => {
    const head = prefix(i + 1, ranges.length)
    const shift = head.length - r.from
    return {
      text: head + text.slice(r.from, r.to),
      mentions: i > 0
        ? []
        : mentions
          .filter(m => m.Start >= r.from && m.End <= r.to)
          .map(m => ({ ...m, Start: m.Start + shift, End: m.End + shift })),
    }
  })
}; exports.splitSmsMessage = splitSmsMessage

const count = (n) => n.toLocaleString('en-US')

/** The plain-SMS counter: from 80% of one text, and past it how many texts
 * the message goes out as. */
 const smsCounter = (text) => {
  const length = text.length
  if (length < Math.ceil(exports.SMS_PART_LENGTH * COUNTER_THRESHOLD)) return null
  const of = `${count(length)} / ${count(exports.SMS_PART_LENGTH)}`
  if (length <= exports.SMS_PART_LENGTH) return { text: of, label: `${count(length)} of ${count(exports.SMS_PART_LENGTH)} characters` }
  const parts = exports.splitSmsText.call(void 0, text).length
  return { text: `${of} · sends as ${parts} texts`, label: `${count(length)} characters, sends as ${parts} texts` }
}; exports.smsCounter = smsCounter
